module.exports = __webpack_public_path__ + "ffac85ceb6ca11adf4338c800711b37e.svg";